<template>
  <div>
    <div calss="">
      <HomeVue v-if="view == 'home'" />
      <AsistenciaVue @setView="setView" v-if="view == 'asistencia'" />
      <MaintenanceVue @setView="setView" v-if="view == 'mantenimiento'" />
      <CitasIseaview @setView="setView" v-if="$store.getters.get_company.id == 11 && view == 'cita'" />
      <Citasview @setView="setView" v-else-if="view == 'cita'" />
      
      <ListaCitasIseaview @setView="setView" v-if="$store.getters.get_company.id == 11 && view == 'lista_citas'" />
      <ListaCitasview @setView="setView" v-else-if="view == 'lista_citas'" /> 
      <CloseBeadVue @setView="setView" v-if="view == 'close_bead'" />
      <ProccessVue v-if="view == 'proccess'" @mtdViewFooter="mtdViewFooter" @setView="setView" />
      <ReportView v-if="view == 'reports'" @setView="setView" />
    </div>
    <FooterVueKatalynas v-if="view == 'home' && $store.getters.get_company.id == 10 && $store.getters.get_rol.id == 2" :view="view" @setView="setView" />
    <FooterVue v-else-if="view == 'home'"  :view="view" @setView="setView" />
  </div>
</template>

<script>
import FooterVueKatalynas from "../../components/administrador/katalynas/Footer.vue";

import FooterVue from "../../components/administrador/Footer.vue";
import HomeVue from "../../components/administrador/Home.vue";
import Citasview from "../../components/citas/Citasview.vue";
import ListaCitasview from "../../components/citas/ListaCitasview.vue";
import ProccessVue from '../proccess/ProccessView.vue';
import CloseBeadVue from "../../components/caja/page/CloseBead.vue";
import MaintenanceVue from "../../views/maintenance/index.vue";
import AsistenciaVue from "../../components/asistencia/Asistencia.vue";
import ReportView from '../reports/ReportsView.vue';
// ISEA
import CitasIseaview from "../../components/citas/isea/Citasview.vue";
import ListaCitasIseaview from "../../components/citas/isea/ListaCitasview.vue";

export default {
  components: {
    FooterVue,
    HomeVue,
    MaintenanceVue,
    Citasview,
    ListaCitasview,
    ProccessVue,
    CloseBeadVue,
    AsistenciaVue,
    ReportView,
    CitasIseaview,
    ListaCitasIseaview,
    FooterVueKatalynas
  },
  data() {
    return {
      view: "home",
    };
  },
  methods: {
    setView: function (payload) {
      this.view = payload;
    },
    mtdViewFooter: function (boo, view) {
      this.booFooter = boo;
      if (boo == true) this.view = view;
    }
  },
};
</script>

<style lang="scss" scoped></style>